import Konva from 'konva';
const FILTER_DEFAULTS = {
    brightness: 1,
    contrast: 1,
    opacity: 1,
};
/**
 * Подготавливает фильтры Konva для применения к изображению.
 */
export function prepareKonvaFilters(filters) {
    if (!filters) {
        return { konvaFilters: [] };
    }
    const konvaFilters = [];
    const result = { konvaFilters };
    if (filters.brightness !== undefined) {
        konvaFilters.push(Konva.Filters.Brightness);
        result.brightness = filters.brightness;
    }
    if (filters.contrast !== undefined) {
        konvaFilters.push(Konva.Filters.Contrast);
        // Преобразуем из диапазона [0, 2] в диапазон [-100, 100]
        result.contrast = (filters.contrast - FILTER_DEFAULTS.contrast) * 100;
    }
    if (filters.opacity !== undefined && filters.opacity !== FILTER_DEFAULTS.opacity) {
        result.opacity = filters.opacity;
    }
    return result;
}
